/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package Embark
 * @since   1.0.0
 */

import './modules/theme/polyfills';
import './modules/theme/webfonts';
import './modules/theme/images';
import './modules/theme/object-fit-videos';
import './modules/theme/lightboxes';
import './modules/theme/forms';
import './modules/theme/scroll-to';
import './modules/theme/sticky-header';
import './modules/theme/main-menu';
import './modules/theme/block-spotlight-slider';
import './modules/theme/comment-reply';
import './modules/theme/acf-blocks';
import './modules/theme/resource-item-overlay';
import './modules/theme/site-search';
import './modules/theme/category-filter';
import './modules/theme/role-image-loading';
import './modules/theme/anchor-links';
import './modules/theme/has-bugherd';
